/**
 * Ticket overview row selection: Shift+click range select and bulk action button state.
 */
export function initTicketOverviewBulk(): void {
    const form = document.getElementById('ticket_overview_form');
    if (!form) {
        return;
    }

    const rowCheckboxes = Array.from(
        form.querySelectorAll<HTMLInputElement>('input[name^="ticket_check_"]'),
    );
    let anchor: HTMLInputElement | null = null;

    const updateBulkActions = (): void => {
        const checkboxes = form.querySelectorAll<HTMLInputElement>('input[name^="ticket_check_"]:checked');
        const hasSelection = checkboxes.length > 0;
        const buttons = [
            document.getElementById('bulk-close-btn'),
            document.getElementById('bulk-reopen-btn'),
            document.getElementById('bulk-delete-btn'),
            document.getElementById('bulk-mark-unread-btn'),
        ];
        for (const btn of buttons) {
            if (!btn) {
                continue;
            }
            if (hasSelection) {
                btn.removeAttribute('disabled');
            } else {
                btn.setAttribute('disabled', 'disabled');
            }
        }
    };

    for (const checkbox of rowCheckboxes) {
        checkbox.addEventListener('click', (e) => {
            if (e.shiftKey && anchor && anchor !== checkbox) {
                const anchorIndex = rowCheckboxes.indexOf(anchor);
                const clickIndex = rowCheckboxes.indexOf(checkbox);
                if (anchorIndex !== -1 && clickIndex !== -1) {
                    const start = Math.min(anchorIndex, clickIndex);
                    const end = Math.max(anchorIndex, clickIndex);
                    const state = checkbox.checked;
                    for (let i = start; i <= end; i++) {
                        rowCheckboxes[i].checked = state;
                    }
                }
            }
            anchor = checkbox;
            updateBulkActions();
        });
    }

    updateBulkActions();
}
